export default "__VITE_ASSET__NkjcKYIJ__"